// @mui
import { SvgIcon } from "@mui/material";

// ----------------------------------------------------------------------

// Hide Eye Icon
export function HideEyeIcon(props) {
  return (
    <SvgIcon
      sx={{ fill: "none" }}
      width="24px"
      height="24px"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        id="Iconly/Light/Hide"
        stroke={props.color || "#000000"}
        strokeWidth="1.5"
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <g id="Hide" transform="translate(2.000000, 3.500000)" stroke={props.color || "#000000"} strokeWidth="1.5">
          <path
            d="M7.7606,10.8668 C7.1856,10.2928 6.8356,9.5128 6.8356,8.6378 C6.8356,6.8848 8.2476,5.4718 9.9996,5.4718 C10.8666,5.4718 11.6646,5.8228 12.2296,6.3968"
            id="Stroke-1"
          />
          <path d="M13.1048,9.1989 C12.8728,10.4889 11.8568,11.5069 10.5678,11.7409" id="Stroke-3" />
          <path
            d="M4.6546,13.9723 C3.0676,12.7263 1.7236,10.9063 0.7496,8.6373 C1.7336,6.3583 3.0866,4.5283 4.6836,3.2723 C6.2706,2.0163 8.1016,1.3343 9.9996,1.3343 C11.9086,1.3343 13.7386,2.0263 15.3356,3.2913"
            id="Stroke-5"
          />
          <path
            d="M17.4476,5.4908 C18.1356,6.4048 18.7406,7.4598 19.2496,8.6368 C17.2826,13.1938 13.8066,15.9388 9.9996,15.9388 C9.1366,15.9388 8.2856,15.7988 7.4676,15.5258"
            id="Stroke-7"
          />
          <line x1="17.887" y1="0.7496" x2="2.113" y2="16.5236" id="Stroke-9" />
        </g>
      </g>
    </SvgIcon>
  );
}

// Eye Icon
export function EyeIcon(props) {
  return (
    <SvgIcon
      sx={{ fill: "none" }}
      width="24px"
      height="24px"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        id="Iconly/Light/Show"
        stroke={props.color || "#000000"}
        strokeWidth="1.5"
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <g id="Show" transform="translate(2.000000, 4.000000)" stroke={props.color || "#000000"} strokeWidth="1.5">
          <path
            d="M13.1615,8.0531 C13.1615,9.7991 11.7455,11.2141 9.9995,11.2141 C8.2535,11.2141 6.8385,9.7991 6.8385,8.0531 C6.8385,6.3061 8.2535,4.8911 9.9995,4.8911 C11.7455,4.8911 13.1615,6.3061 13.1615,8.0531 Z"
            id="Stroke-1"
          />
          <path
            d="M9.998,15.3549 C13.806,15.3549 17.289,12.6169 19.25,8.0529 C17.289,3.4889 13.806,0.7509 9.998,0.7509 L10.002,0.7509 C6.194,0.7509 2.711,3.4889 0.75,8.0529 C2.711,12.6169 6.194,15.3549 10.002,15.3549 L9.998,15.3549 Z"
            id="Stroke-3"
          />
        </g>
      </g>
    </SvgIcon>
  );
}

// Moon Icon
export function MoonIcon(props) {
  return (
    <SvgIcon
      sx={{ fill: "none" }}
      width="24px"
      height="24px"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.0262 14.276C21.072 14.2516 21.1264 14.2935 21.1118 14.3441C20.0134 18.1872 16.4728 21 12.2911 21C7.21912 21 3.11426 16.8854 3.11426 11.8232C3.11426 7.6317 5.91732 4.0999 9.76144 3.00241C9.81106 2.98782 9.85289 3.0423 9.82857 3.08803C8.16969 6.20925 8.66492 10.1867 11.2958 12.8185C13.9276 15.4493 17.905 15.9446 21.0262 14.276Z"
        stroke={props.color || "#000000"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
}

// Sun Icon
export function SunIcon(props) {
  return (
    <SvgIcon
      sx={{ fill: "none" }}
      width="24px"
      height="24px"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.0548 3V4.3719M12.0548 19.6281V21M21.0547 12.0001H19.6828M4.42659 12.0001H3.05469M18.4185 5.63582L17.4485 6.60589M6.66105 17.3938L5.69099 18.3639M18.4185 18.3639L17.4485 17.3938M6.66105 6.60636L5.69099 5.6363"
        stroke={props.color || "#000000"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.0549 7.80469C14.3725 7.80469 16.2504 9.68351 16.2504 12.0002C16.2504 14.3178 14.3725 16.1966 12.0549 16.1966C9.73723 16.1966 7.85938 14.3178 7.85938 12.0002C7.85938 9.68351 9.73723 7.80469 12.0549 7.80469Z"
        stroke={props.color || "#000000"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
}

// ArrowDown Icon
export function ArrowDownIcon(props) {
  return (
    <SvgIcon width="24px" height="24px" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g
        id="Iconly/Light/Arrow---Down-2"
        stroke={props.color || "#000000"}
        strokeWidth="1.5"
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <g
          id="Arrow---Down-2"
          transform="translate(5.000000, 8.500000)"
          stroke={props.color || "#000000"}
          strokeWidth="1.5"
        >
          <polyline id="Stroke-1" points="14 0 7 7 0 0" />
        </g>
      </g>
    </SvgIcon>
  );
}

// ArrowUp Icon
export function ArrowUpIcon(props) {
  return (
    <SvgIcon width="24px" height="24px" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g
        id="Iconly/Light/Arrow---Up-2"
        stroke={props.color || "#000000"}
        strokeWidth="1.5"
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <g
          id="Arrow---Up-2"
          transform="translate(12.000000, 12.000000) rotate(-180.000000) translate(-12.000000, -12.000000) translate(5.000000, 8.500000)"
          stroke={props.color || "#000000"}
          strokeWidth="1.5"
        >
          <polyline id="Stroke-1" points="14 0 7 7 0 0" />
        </g>
      </g>
    </SvgIcon>
  );
}

// ArrowUpCircle Icon
export function DoubleUpCircleIcon(props) {
  return (
    <SvgIcon width="24px" height="24px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.25 12C2.25 6.61589 6.61481 2.25 12 2.25C17.3852 2.25 21.75 6.61589 21.75 12C21.75 17.3841 17.3852 21.75 12 21.75C6.61481 21.75 2.25 17.3841 2.25 12ZM12 3.75C7.44335 3.75 3.75 7.44421 3.75 12C3.75 16.5558 7.44335 20.25 12 20.25C16.5567 20.25 20.25 16.5558 20.25 12C20.25 7.44421 16.5567 3.75 12 3.75Z"
        fill={props.color || "#000000"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.4693 12.2197C11.7622 11.9268 12.237 11.9268 12.5299 12.2196L15.5306 15.2193C15.8235 15.5121 15.8236 15.987 15.5307 16.2799C15.2379 16.5729 14.763 16.5729 14.4701 16.2801L11.9998 13.8106L9.53033 16.28C9.23744 16.5729 8.76256 16.5729 8.46967 16.28C8.17678 15.9871 8.17678 15.5122 8.46967 15.2193L11.4693 12.2197Z"
        fill={props.color || "#000000"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.4693 6.96967C11.7622 6.67681 12.237 6.67677 12.5299 6.96958L15.5306 9.96926C15.8235 10.2621 15.8236 10.737 15.5307 11.0299C15.2379 11.3229 14.763 11.3229 14.4701 11.0301L11.9998 8.56057L9.53033 11.03C9.23744 11.3229 8.76256 11.3229 8.46967 11.03C8.17678 10.7371 8.17678 10.2622 8.46967 9.96935L11.4693 6.96967Z"
        fill={props.color || "#000000"}
      />
    </SvgIcon>
  );
}

// ArrowDownCircle Icon
export function DoubleDownCircleIcon(props) {
  return (
    <SvgIcon width="24px" height="24px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.53 8.78L12.531 11.78C12.39 11.921 12.2 12 12.001 12C11.801 12 11.611 11.921 11.47 11.78L8.469 8.78C8.176 8.488 8.176 8.012 8.469 7.719C8.762 7.426 9.237 7.426 9.53 7.719L12.001 10.189L14.469 7.719C14.762 7.426 15.237 7.426 15.53 7.719C15.823 8.012 15.823 8.487 15.53 8.78ZM15.53 14.03L12.531 17.03C12.39 17.171 12.2 17.25 12.001 17.25C11.801 17.25 11.611 17.171 11.47 17.03L8.469 14.03C8.176 13.738 8.176 13.262 8.469 12.969C8.762 12.676 9.237 12.676 9.53 12.969L12.001 15.439L14.469 12.969C14.762 12.676 15.237 12.676 15.53 12.969C15.823 13.262 15.823 13.737 15.53 14.03ZM12 2.5C6.761 2.5 2.5 6.761 2.5 12C2.5 17.238 6.761 21.5 12 21.5C17.238 21.5 21.5 17.238 21.5 12C21.5 6.761 17.238 2.5 12 2.5Z"
        fill={props.color || "#000000"}
      />
    </SvgIcon>
  );
}

// Close Icon
export function CloseIcon(props) {
  return (
    <SvgIcon width="24px" height="24px" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        strokeWidth="evenodd"
        clipRule="evenodd"
        d="M13.414 12.0002L18.707 6.70725C19.098 6.31625 19.098 5.68425 18.707 5.29325C18.316 4.90225 17.684 4.90225 17.293 5.29325L12 10.5862L6.70701 5.29325C6.31601 4.90225 5.68401 4.90225 5.29301 5.29325C4.90201 5.68425 4.90201 6.31625 5.29301 6.70725L10.586 12.0002L5.29301 17.2933C4.90201 17.6842 4.90201 18.3162 5.29301 18.7072C5.48801 18.9022 5.74401 19.0002 6.00001 19.0002C6.25601 19.0002 6.51201 18.9022 6.70701 18.7072L12 13.4143L17.293 18.7072C17.488 18.9022 17.744 19.0002 18 19.0002C18.256 19.0002 18.512 18.9022 18.707 18.7072C19.098 18.3162 19.098 17.6842 18.707 17.2933L13.414 12.0002Z"
        fill={props.color || "#000000"}
      />
    </SvgIcon>
  );
}

// Checlk Mark Icon
export function CheckMarkIcon(props) {
  return (
    <SvgIcon width="24px" height="24px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M19 7.1875L9.375 16.8125L5 12.4375"
        stroke="#000000"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>

    // <SvgIcon width="24px" height="24px" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    //   <path
    //     strokeWidth="evenodd"
    //     clipRule="evenodd"
    //     d="M13.414 12.0002L18.707 6.70725C19.098 6.31625 19.098 5.68425 18.707 5.29325C18.316 4.90225 17.684 4.90225 17.293 5.29325L12 10.5862L6.70701 5.29325C6.31601 4.90225 5.68401 4.90225 5.29301 5.29325C4.90201 5.68425 4.90201 6.31625 5.29301 6.70725L10.586 12.0002L5.29301 17.2933C4.90201 17.6842 4.90201 18.3162 5.29301 18.7072C5.48801 18.9022 5.74401 19.0002 6.00001 19.0002C6.25601 19.0002 6.51201 18.9022 6.70701 18.7072L12 13.4143L17.293 18.7072C17.488 18.9022 17.744 19.0002 18 19.0002C18.256 19.0002 18.512 18.9022 18.707 18.7072C19.098 18.3162 19.098 17.6842 18.707 17.2933L13.414 12.0002Z"
    //     fill={props.color || "#000000"}
    //   />
    // </SvgIcon>
  );
}

// Login Icon
export function LoginIcon(props) {
  return (
    <SvgIcon width="24px" height="24px" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g
        id="Iconly/Light/Login"
        stroke={props.color || "#000000"}
        strokeWidth="1.5"
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <g id="Login" transform="translate(3.000000, 2.000000)" stroke={props.color || "#000000"} strokeWidth="1.5">
          <line x1="12.8125" y1="10.0218" x2="0.7715" y2="10.0218" id="Stroke-1" />
          <polyline id="Stroke-3" points="9.8848 7.1058 12.8128 10.0218 9.8848 12.9378" />
          <path
            d="M5.5044,5.389 L5.5044,4.456 C5.5044,2.421 7.1534,0.772 9.1894,0.772 L14.0734,0.772 C16.1034,0.772 17.7484,2.417 17.7484,4.447 L17.7484,15.587 C17.7484,17.622 16.0984,19.272 14.0634,19.272 L9.1784,19.272 C7.1494,19.272 5.5044,17.626 5.5044,15.597 L5.5044,14.655"
            id="Stroke-4"
          />
        </g>
      </g>
    </SvgIcon>
  );
}

// Profile_Ico
export function ProfileIcon(props) {
  return (
    <SvgIcon width="24px" height="24px" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g
        id="Iconly/Light/Profile"
        stroke={props.color || "#000000"}
        strokeWidth="1.5"
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <g id="Profile" transform="translate(4.814286, 2.814476)" stroke={props.color || "#000000"}>
          <path
            d="M7.17047619,12.531714 C3.30285714,12.531714 -4.08562073e-14,13.1164759 -4.08562073e-14,15.4583807 C-4.08562073e-14,17.8002854 3.28190476,18.4059997 7.17047619,18.4059997 C11.0380952,18.4059997 14.34,17.8202854 14.34,15.479333 C14.34,13.1383807 11.0590476,12.531714 7.17047619,12.531714 Z"
            id="Stroke-1"
            strokeWidth="1.5"
          />
          <path
            d="M7.17047634,9.19142857 C9.70857158,9.19142857 11.7657144,7.13333333 11.7657144,4.5952381 C11.7657144,2.05714286 9.70857158,-5.32907052e-15 7.17047634,-5.32907052e-15 C4.6323811,-5.32907052e-15 2.574259,2.05714286 2.574259,4.5952381 C2.56571443,7.1247619 4.60952396,9.18285714 7.13809539,9.19142857 L7.17047634,9.19142857 Z"
            id="Stroke-3"
            strokeWidth="1.5"
          />
        </g>
      </g>
    </SvgIcon>
  );
}

// Menu-Ico
export function HamburgerIcon(props) {
  return (
    <SvgIcon width="24px" height="24px" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20 20H4C3.448 20 3 19.553 3 19C3 18.447 3.448 18 4 18H20C20.552 18 21 18.447 21 19C21 19.553 20.552 20 20 20Z"
        fill={props.color || "#000000"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20 6H4C3.448 6 3 5.553 3 5C3 4.447 3.448 4 4 4H20C20.552 4 21 4.447 21 5C21 5.553 20.552 6 20 6Z"
        fill={props.color || "#000000"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20 13H4C3.448 13 3 12.553 3 12C3 11.447 3.448 11 4 11H20C20.552 11 21 11.447 21 12C21 12.553 20.552 13 20 13Z"
        fill={props.color || "#000000"}
      />
    </SvgIcon>
  );
}

// Chat Icon
export function ChatIcon(props) {
  return (
    <SvgIcon width="24px" height="24px" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.2608 3.19727H10.4308C8.94758 3.19727 7.68751 4.17898 7.2829 5.52692C7.24621 5.64913 7.34139 5.76727 7.46899 5.76727H14.1808C16.6808 5.76727 18.7208 7.80727 18.7208 10.3173V14.8679C18.7208 14.9892 18.8282 15.083 18.9469 15.058C20.4352 14.7451 21.5508 13.4182 21.5508 11.8373V6.48727C21.5508 4.67727 20.0708 3.19727 18.2608 3.19727Z"
        fill={props.color || "#000000"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.4508 14.1673C11.8808 14.1673 11.4208 13.7073 11.4208 13.1373C11.4208 12.5673 11.8808 12.0973 12.4508 12.0973C13.0208 12.0973 13.4908 12.5673 13.4908 13.1373C13.4908 13.7073 13.0208 14.1673 12.4508 14.1673ZM7.77078 14.1673C7.20078 14.1673 6.73078 13.7073 6.73078 13.1373C6.73078 12.5673 7.20078 12.0973 7.77078 12.0973C8.34078 12.0973 8.80078 12.5673 8.80078 13.1373C8.80078 13.7073 8.34078 14.1673 7.77078 14.1673ZM14.1808 7.01733H6.35078C4.53078 7.01733 3.05078 8.49733 3.05078 10.3173V15.6673C3.05078 17.4773 4.53078 18.9573 6.35078 18.9573H7.17078C7.55078 18.9573 7.91078 19.1073 8.18078 19.3773L9.28078 20.4773C9.54078 20.7373 9.89078 20.8873 10.2608 20.8873C10.6308 20.8873 10.9808 20.7373 11.2508 20.4773L12.3508 19.3773C12.6108 19.1073 12.9708 18.9573 13.3508 18.9573H14.1808C15.9908 18.9573 17.4708 17.4773 17.4708 15.6673V10.3173C17.4708 8.49733 15.9908 7.01733 14.1808 7.01733Z"
        fill={props.color || "#000000"}
      />
    </SvgIcon>
  );
}

// Facebook icon
export function FacebookIcon(props) {
  return (
    <SvgIcon
      sx={{ fill: "none" }}
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 21C16.9709 21 21 16.9709 21 12C21 7.02908 16.9709 3 12 3C7.02908 3 3 7.02908 3 12C3 16.9709 7.02908 21 12 21Z"
        stroke={props.color || "#000000"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.0835 7.91016H13.3538C12.2222 7.91016 11.3047 8.82767 11.3047 9.95924V16.0919"
        stroke={props.color || "#000000"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.91602 11.3828H14.0842"
        stroke={props.color || "#000000"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
}

// Twitter icon
export function TwitterIcon(props) {
  return (
    <SvgIcon
      sx={{ fill: "none" }}
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.4004 7.84021L21 5.41848L18.7194 5.76C18.7194 5.76 16.9631 3.40151 14.3867 4.18475C12.3006 4.81913 11.461 7.27978 11.6546 8.80054C8.74346 8.41037 6.04541 7.06183 3.98757 4.96702C2.91243 11.3663 5.01405 14.472 8.16746 16.2399C6.65157 17.2849 4.84086 17.8171 3 17.7587C4.63751 19.7329 7.98649 20.0724 9.8293 19.9557C16.2568 19.5499 19.8305 14.4983 19.4257 8.07178L19.4004 7.84021Z"
        stroke={props.color || "#000000"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
}

// Instagram icon
export function InstagramIcon(props) {
  return (
    <SvgIcon
      sx={{ fill: "none" }}
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.78216 3H16.2169C19.165 3 21 5.08119 21 8.02638V15.9736C21 18.9188 19.165 21 16.2159 21H7.78216C4.83405 21 3 18.9188 3 15.9736V8.02638C3 5.08119 4.84281 3 7.78216 3Z"
        stroke={props.color || "#000000"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.8445 8.82617C9.91023 8.82617 8.3418 10.3946 8.3418 12.3289C8.3418 14.2631 9.91023 15.8316 11.8445 15.8316C13.7788 15.8316 15.3472 14.2631 15.3472 12.3289C15.3472 10.3946 13.7788 8.82617 11.8445 8.82617Z"
        stroke={props.color || "#000000"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.8661 7.36569V7.43469V7.36569ZM17.1481 7.38071C17.1481 7.53771 17.0211 7.6647 16.8641 7.6647C16.7071 7.6647 16.5791 7.53771 16.5791 7.38071C16.5791 7.22371 16.7071 7.0957 16.8641 7.0957C17.0211 7.0957 17.1481 7.22371 17.1481 7.38071Z"
        stroke={props.color || "#000000"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
}

// calling icon
export function CallingIcon(props) {
  return (
    <SvgIcon width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <g
        id="Iconly/Light/Calling"
        stroke={props.color || "#000000"}
        strokeWidth="1.5"
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <g id="Calling" transform="translate(2.000000, 2.500000)" stroke={props.color || "#000000"} strokeWidth="1.5">
          <path d="M12.353,1.95399252e-14 C16.054,0.411 18.978,3.331 19.393,7.032" id="Stroke-1" />
          <path d="M12.353,3.543 C14.124,3.887 15.508,5.272 15.853,7.043" id="Stroke-3" />
          <path
            d="M9.03152183,9.97238745 C13.0205087,13.9603606 13.9254376,9.34671782 16.46525,11.8848116 C18.9138181,14.3327574 20.322201,14.8232052 17.2188207,17.9247236 C16.8302273,18.2370218 14.3612634,21.9942591 5.68446558,13.3196663 C-2.9934057,4.64400029 0.761566311,2.17244427 1.07394391,1.78394958 C4.18376493,-1.32615434 4.66682308,0.0893829491 7.11539117,2.53732879 C9.65413011,5.07649576 5.04253498,5.9844143 9.03152183,9.97238745 Z"
            id="Stroke-5"
          />
        </g>
      </g>
    </SvgIcon>
  );
}

// email Icon
export function EmailIcon(props) {
  return (
    <SvgIcon width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <title>Iconly/Light/Message</title>
      <g
        id="Iconly/Light/Message"
        stroke={props.color || "#000000"}
        strokeWidth="1.5"
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <g id="Message" transform="translate(2.000000, 3.000000)" stroke={props.color || "#000000"} strokeWidth="1.5">
          <path
            d="M15.9026143,5.8511436 L11.4593272,9.46418164 C10.6198313,10.1301843 9.4387043,10.1301843 8.59920842,9.46418164 L4.11842516,5.8511436"
            id="Stroke-1"
          />
          <path
            d="M14.9088637,17.9999789 C17.9502135,18.0083748 20,15.5095497 20,12.4383622 L20,5.57001263 C20,2.49882508 17.9502135,5.32907052e-15 14.9088637,5.32907052e-15 L5.09113634,5.32907052e-15 C2.04978648,5.32907052e-15 1.77635684e-15,2.49882508 1.77635684e-15,5.57001263 L1.77635684e-15,12.4383622 C1.77635684e-15,15.5095497 2.04978648,18.0083748 5.09113634,17.9999789 L14.9088637,17.9999789 Z"
            id="Stroke-3"
          />
        </g>
      </g>
    </SvgIcon>
  );
}

// message Badge Icon
export function MessageBadgeIcon(props) {
  return (
    <SvgIcon width="30px" height="30px" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.5757 12.898C14.0057 12.898 13.5457 12.438 13.5457 11.868C13.5457 11.298 14.0057 10.828 14.5757 10.828C15.1457 10.828 15.6157 11.298 15.6157 11.868C15.6157 12.438 15.1457 12.898 14.5757 12.898ZM9.9357 12.898C9.3657 12.898 8.8957 12.438 8.8957 11.868C8.8957 11.298 9.3657 10.828 9.9357 10.828C10.5057 10.828 10.9657 11.298 10.9657 11.868C10.9657 12.438 10.5057 12.898 9.9357 12.898ZM20.3115 9.03175C20.2768 8.92499 20.1595 8.8714 20.0527 8.90586C19.6888 9.02321 19.3045 9.08799 18.9057 9.08799C16.8257 9.08799 15.1257 7.39799 15.1257 5.30799C15.1257 4.79227 15.225 4.29948 15.417 3.85632C15.4622 3.75207 15.4199 3.62818 15.3155 3.58342C14.6095 3.28081 13.8552 3.08053 13.0757 2.99799C10.6857 2.73799 8.3957 3.42799 6.5957 4.95799C4.6957 6.57799 3.5357 8.99799 3.4157 11.598C3.1757 16.798 7.3757 20.748 11.6557 21.968C11.7457 21.988 11.8357 22.008 11.9257 22.008C12.1357 22.008 12.3457 21.938 12.5257 21.798C12.7757 21.608 12.9357 21.308 12.9357 20.988L12.9257 19.498C12.9257 19.498 12.9357 19.488 12.9457 19.488C17.9457 18.888 21.1257 15.308 20.6757 10.778C20.613 10.1774 20.494 9.59296 20.3115 9.03175Z"
        fill={props.color || "#000000"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.9057 7.58783C19.1657 7.58783 19.4157 7.54783 19.6457 7.46783C20.5457 7.16783 21.1957 6.31783 21.1957 5.30783C21.1957 4.04783 20.1757 3.02783 18.9057 3.02783C17.9757 3.02783 17.1757 3.58783 16.8257 4.38783C16.6957 4.66783 16.6257 4.97783 16.6257 5.30783C16.6257 6.56783 17.6457 7.58783 18.9057 7.58783Z"
        fill={props.color || "#000000"}
      />
    </SvgIcon>
  );
}

// Barcode-RateIcon
export function BarcodeIcon(props) {
  return (
    <SvgIcon width="30px" height="30px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.91272 8.10791V15.6389C5.91272 16.1909 6.36072 16.6389 6.91272 16.6389C7.46472 16.6389 7.91272 16.1909 7.91272 15.6389V8.10791C7.91272 7.55591 7.46472 7.10791 6.91272 7.10791C6.36072 7.10791 5.91272 7.55591 5.91272 8.10791Z"
        fill={props.color || "#000000"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.5167 11.1338V8.10782C14.5167 7.55582 14.0687 7.10782 13.5167 7.10782C12.9647 7.10782 12.5167 7.55582 12.5167 8.10782V11.1338C12.5167 11.6858 12.9647 12.1338 13.5167 12.1338C14.0687 12.1338 14.5167 11.6858 14.5167 11.1338Z"
        fill={props.color || "#000000"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.8175 8.10791V9.90091C15.8175 10.4529 16.2655 10.9009 16.8175 10.9009C17.3695 10.9009 17.8175 10.4529 17.8175 9.90091V8.10791C17.8175 7.55591 17.3695 7.10791 16.8175 7.10791C16.2655 7.10791 15.8175 7.55591 15.8175 8.10791Z"
        fill={props.color || "#000000"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.2135 10.9541C9.6615 10.9541 9.2135 11.4021 9.2135 11.9541V15.5481C9.2135 16.1001 9.6615 16.5481 10.2135 16.5481C10.7655 16.5481 11.2135 16.1001 11.2135 15.5481V11.9541C11.2135 11.4021 10.7655 10.9541 10.2135 10.9541Z"
        fill={props.color || "#000000"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.2135 7.10892C9.6615 7.10892 9.2135 7.55692 9.2135 8.10892V9.05692C9.2135 9.60892 9.6615 10.0569 10.2135 10.0569C10.7655 10.0569 11.2135 9.60892 11.2135 9.05692V8.10892C11.2135 7.55692 10.7655 7.10892 10.2135 7.10892Z"
        fill={props.color || "#000000"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.3224 4.87402H17.4324C18.9164 4.87402 20.1234 6.08102 20.1234 7.56402V8.95802C20.1234 9.37202 20.4594 9.70802 20.8734 9.70802C21.2874 9.70802 21.6234 9.37202 21.6234 8.95802V7.56402C21.6234 5.25302 19.7434 3.37402 17.4324 3.37402H16.3224C15.9084 3.37402 15.5724 3.71002 15.5724 4.12402C15.5724 4.53802 15.9084 4.87402 16.3224 4.87402Z"
        fill={props.color || "#000000"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.87561 9.70802C3.28961 9.70802 3.62561 9.37202 3.62561 8.95802V7.56402C3.62561 6.08102 4.83261 4.87402 6.31561 4.87402H7.42561C7.83961 4.87402 8.17561 4.53802 8.17561 4.12402C8.17561 3.71002 7.83961 3.37402 7.42561 3.37402H6.31561C4.00461 3.37402 2.12561 5.25302 2.12561 7.56402V8.95802C2.12561 9.37202 2.46161 9.70802 2.87561 9.70802Z"
        fill={props.color || "#000000"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.45573 18.877H6.31573C4.83173 18.877 3.62573 17.67 3.62573 16.187V14.794C3.62573 14.38 3.28973 14.044 2.87573 14.044C2.46173 14.044 2.12573 14.38 2.12573 14.794V16.187C2.12573 18.498 4.00473 20.377 6.31573 20.377H7.45573C7.86973 20.377 8.20573 20.041 8.20573 19.627C8.20573 19.213 7.86973 18.877 7.45573 18.877Z"
        fill={props.color || "#000000"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.2174 15.8618C15.2174 14.7328 16.1364 13.8138 17.2654 13.8138C18.3954 13.8138 19.3134 14.7328 19.3134 15.8618C19.3134 16.9918 18.3954 17.9108 17.2654 17.9108C16.1364 17.9108 15.2174 16.9918 15.2174 15.8618ZM21.5814 18.9178L20.6794 18.0178C21.0754 17.3918 21.3134 16.6558 21.3134 15.8618C21.3134 13.6298 19.4974 11.8138 17.2654 11.8138C15.0334 11.8138 13.2174 13.6298 13.2174 15.8618C13.2174 18.0948 15.0334 19.9108 17.2654 19.9108C17.9774 19.9108 18.6374 19.7108 19.2184 19.3868L20.1684 20.3338C20.3634 20.5288 20.6184 20.6258 20.8744 20.6258C21.1314 20.6258 21.3874 20.5288 21.5824 20.3328C21.9724 19.9418 21.9714 19.3078 21.5814 18.9178Z"
        fill={props.color || "#000000"}
      />
    </SvgIcon>
  );
}
// Truck Icon
export function TruckIcon(props) {
  return (
    <SvgIcon width="30px" height="30px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.6 13.1599H20.25V15.0999C20.25 15.8399 19.65 16.4299 18.92 16.4299H18.75C18.5 15.5699 17.82 14.8799 16.95 14.6299V9.1599L19.29 10.1899C19.87 10.4399 20.25 11.0199 20.25 11.6599H18.6C18.18 11.6599 17.85 11.9999 17.85 12.4099C17.85 12.8299 18.18 13.1599 18.6 13.1599ZM16.2 18.3499C15.65 18.3499 15.2 17.9799 15.07 17.4799C15.04 17.3799 15.03 17.2799 15.03 17.1799C15.03 16.8199 15.19 16.4999 15.45 16.2899C15.65 16.1199 15.91 16.0199 16.2 16.0199C16.49 16.0199 16.75 16.1199 16.95 16.2999C17.2 16.5099 17.36 16.8299 17.36 17.1799C17.36 17.8299 16.84 18.3499 16.2 18.3499ZM8.96 8.2199H5.39C4.98 8.2199 4.64 7.8799 4.64 7.4699C4.64 7.0499 4.98 6.7199 5.39 6.7199H8.96C9.37 6.7199 9.71 7.0499 9.71 7.4699C9.71 7.8799 9.37 8.2199 8.96 8.2199ZM8.22 17.1899C8.22 17.2199 8.22 17.2399 8.21 17.2699C8.17 17.8799 7.67 18.3499 7.05 18.3499C6.42 18.3499 5.9 17.8399 5.89 17.1999V17.1799C5.89 16.5399 6.41 16.0199 7.05 16.0199C7.7 16.0199 8.22 16.5399 8.22 17.1799V17.1899ZM19.89 8.8199L16.95 7.5199V6.9799C16.95 5.4199 15.68 4.1499 14.12 4.1499H5.05C3.5 4.1499 2.25 5.4099 2.25 6.9499V9.07816C2.25 9.24452 2.38403 9.37913 2.55039 9.3782C3.41421 9.37336 5.90281 9.3599 6.84 9.3599C7.25 9.3599 7.59 9.6999 7.59 10.1099C7.59 10.5299 7.25 10.8599 6.84 10.8599C5.70337 10.8599 3.37833 10.8533 2.55072 10.8508C2.38467 10.8503 2.25 10.9848 2.25 11.1508V15.0999C2.25 16.4499 3.21 17.5899 4.48 17.8599C4.77 18.9999 5.82 19.8499 7.05 19.8499C8.26 19.8499 9.29 19.0399 9.61 17.9299H13.64C13.96 19.0399 14.99 19.8499 16.2 19.8499C17.41 19.8499 18.43 19.0399 18.75 17.9299H18.92C20.48 17.9299 21.75 16.6599 21.75 15.0999V11.6599C21.75 10.4199 21.02 9.2999 19.89 8.8199Z"
        fill={props.color || "#000000"}
      />
    </SvgIcon>
  );
}

// DoubleUp Icon
export function DoubleUpIcon(props) {
  return (
    <SvgIcon
      sx={{ fill: "none" }}
      width="30"
      height="30"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M16.3633 11.25L11.9996 6.25028L7.63601 11.25"
        stroke={props.color || "#000000"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.3633 18.25L11.9996 13.2503L7.63601 18.25"
        stroke={props.color || "#000000"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
}

// Heart-RateIcon
export function HeartRateIcon(props) {
  return (
    <SvgIcon width="30" height="30" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.9822 6.97682C20.3012 5.29582 18.9882 4.07082 17.2852 3.52382C16.3592 3.22382 15.3532 3.15382 14.3762 3.31782C13.4822 3.46682 12.6732 4.00182 11.9932 4.49882C11.3372 4.02282 10.5062 3.47782 9.61125 3.32782C8.64625 3.16582 7.64125 3.23282 6.70325 3.52482C3.55225 4.54482 2.24925 7.61482 2.54825 10.4998H7.26925L8.57625 8.01182C8.70625 7.76482 8.96125 7.61082 9.24025 7.61082H9.24125C9.52025 7.61082 9.77525 7.76582 9.90425 8.01182L12.2752 12.5348L13.1282 10.9028C13.2582 10.6558 13.5142 10.4998 13.7932 10.4998H16.8942C17.3082 10.4998 17.6442 10.8358 17.6442 11.2498C17.6442 11.6638 17.3082 11.9998 16.8942 11.9998H14.2472L12.9402 14.4978C12.8112 14.7458 12.5552 14.9008 12.2762 14.9008C11.9982 14.9008 11.7412 14.7468 11.6112 14.4988L9.24025 9.97482L8.38625 11.5988C8.25625 11.8458 8.00125 11.9998 7.72225 11.9998H2.85125C2.85725 12.0198 2.86125 12.0398 2.86725 12.0588C4.49025 17.2698 11.4862 20.5838 11.7832 20.7228C11.8502 20.7538 11.9222 20.7698 11.9942 20.7698C12.0662 20.7698 12.1382 20.7538 12.2052 20.7228C12.4982 20.5868 19.3892 17.3318 21.1112 12.0638C21.6622 10.3478 21.6162 8.54182 20.9822 6.97682Z"
        fill={props.color || "#000000"}
      />
    </SvgIcon>
  );
}

// SearchIcon
export function SearchIcon(props) {
  return (
    <SvgIcon width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g
        id="Iconly/Light/Search"
        stroke={props.color || "#000000"}
        strokeWidth="1.5"
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <g id="Search" transform="translate(2.000000, 2.000000)" stroke={props.color || "#000000"} strokeWidth="1.5">
          <circle id="Ellipse_739" cx="9.76659044" cy="9.76659044" r="8.9885584" />
          <line x1="16.0183067" y1="16.4851259" x2="19.5423342" y2="20.0000001" id="Line_181" />
        </g>
      </g>
    </SvgIcon>
  );
}

// LeftArrow
export function LeftArrowIcon(props) {
  return (
    <SvgIcon width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g
        id="Iconly/Light/Arrow---Left"
        stroke={props.color || "#000000"}
        strokeWidth="1.5"
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <g
          id="Arrow---Left"
          transform="translate(12.000000, 12.000000) rotate(-270.000000) translate(-12.000000, -12.000000) translate(5.500000, 4.000000)"
          stroke={props.color || "#000000"}
          strokeWidth="1.5"
        >
          <line x1="6.7743" y1="15.75" x2="6.7743" y2="0.75" id="Stroke-1" />
          <polyline id="Stroke-3" points="12.7987 9.7002 6.7747 15.7502 0.7497 9.7002" />
        </g>
      </g>
    </SvgIcon>
  );
}

// GiftIcon
export function GiftIcon(props) {
  return (
    <SvgIcon width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#clip0_135_12953)">
        <path
          d="M4.34961 12H19.6497V18C19.6497 19.66 18.3097 21 16.6497 21H7.34961C5.68961 21 4.34961 19.66 4.34961 18V12Z"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M20 8.3999H4C3.44772 8.3999 3 8.84762 3 9.3999V10.9999C3 11.5522 3.44772 11.9999 4 11.9999H20C20.5523 11.9999 21 11.5522 21 10.9999V9.3999C21 8.84762 20.5523 8.3999 20 8.3999Z"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.5797 12H10.4297V21H13.5797V12Z"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.76018 8.27005C11.9202 8.69005 12.4602 8.17005 12.0502 5.98005C11.5702 3.42005 9.04017 2.13005 7.50017 3.66005C5.94017 5.19005 7.22018 7.78005 9.76018 8.27005V8.27005Z"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.5905 8.27005C12.4305 8.69005 11.8905 8.17005 12.3005 5.98005C12.7805 3.42005 15.3105 2.13005 16.8505 3.66005C18.4105 5.19005 17.1305 7.78005 14.5905 8.27005V8.27005Z"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_135_12953">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </SvgIcon>
  );
}

// StarIcon
export function StarIcon(props) {
  return (
    <SvgIcon {...props}>
      <path d="M17.56,21 C17.4000767,21.0006435 17.2423316,20.9629218 17.1,20.89 L12,18.22 L6.9,20.89 C6.56213339,21.067663 6.15259539,21.0374771 5.8444287,20.8121966 C5.53626201,20.5869161 5.38323252,20.2058459 5.45,19.83 L6.45,14.2 L2.33,10.2 C2.06805623,9.93860108 1.9718844,9.55391377 2.08,9.2 C2.19824414,8.83742187 2.51242293,8.57366684 2.89,8.52 L8.59,7.69 L11.1,2.56 C11.2670864,2.21500967 11.6166774,1.99588989 12,1.99588989 C12.3833226,1.99588989 12.7329136,2.21500967 12.9,2.56 L15.44,7.68 L21.14,8.51 C21.5175771,8.56366684 21.8317559,8.82742187 21.95,9.19 C22.0581156,9.54391377 21.9619438,9.92860108 21.7,10.19 L17.58,14.19 L18.58,19.82 C18.652893,20.2027971 18.4967826,20.5930731 18.18,20.82 C17.9989179,20.9468967 17.7808835,21.010197 17.56,21 L17.56,21 Z" />
    </SvgIcon>
  );
}

// Using for Alert
export function InfoIcon(props) {
  return (
    <SvgIcon {...props}>
      <path d="M12,2 C6.4771525,2 2,6.4771525 2,12 C2,17.5228475 6.4771525,22 12,22 C17.5228475,22 22,17.5228475 22,12 C22,9.3478351 20.9464316,6.80429597 19.0710678,4.92893219 C17.195704,3.0535684 14.6521649,2 12,2 Z M13,16 C13,16.5522847 12.5522847,17 12,17 C11.4477153,17 11,16.5522847 11,16 L11,11 C11,10.4477153 11.4477153,10 12,10 C12.5522847,10 13,10.4477153 13,11 L13,16 Z M12,9 C11.4477153,9 11,8.55228475 11,8 C11,7.44771525 11.4477153,7 12,7 C12.5522847,7 13,7.44771525 13,8 C13,8.55228475 12.5522847,9 12,9 Z" />
    </SvgIcon>
  );
}

// Using for Sign-in
export function SignInIcon(props) {
  return (
    <SvgIcon {...props}>
      <path
        d="M8.49188 7.43278V6.561C8.49188 4.66076 10.0326 3.12 11.9329 3.12H16.4956C18.392 3.12 19.9289 4.65692 19.9289 6.55235V16.958C19.9289 18.8592 18.3872 20.4 16.487 20.4H11.9233C10.0278 20.4 8.49188 18.863 8.49188 16.9676V16.0882"
        stroke="white"
        strokeWidth="1.44"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.3174 11.7614H4.07062M12.5842 9.03751L15.3187 11.7614L12.5842 14.4845"
        stroke="white"
        strokeWidth="1.44"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
}
